import React, { useEffect, useState } from 'react'

import { Space } from 'antd'
import CanvasTableAPI from 'app/components/TableAPI/CanvasTableAPI'
import { useCoinGlobal } from '../../hooks/stateStore/coinGlobal'
import ExceptBox from './ExceptBox'
import { PartnerRealtimeWaitColumn } from './PartnerRealtimeWait_Column'
import SearchFilter from './SearchFilter'

const PartnerRealtimeWait = ({
	height = 500,
	width = 100,
	scale = 1,
	group,
}) => {
	const [search, setSearch] = React.useState('')
	const [search2, setSearch2] = React.useState('')

	const { data: coinglobal } = useCoinGlobal()

	const [exceptType1, setExceptType1] = useState(true)
	const [exceptType2, setExceptType2] = useState(true)
	const [exceptType3, setExceptType3] = useState(true)
	const [exceptType4, setExceptType4] = useState(true)
	const [exceptType5, setExceptType5] = useState(true)

	const [exceptType, setExceptType] = useState('')
	const [api, setApi] =
		React.useState<any>(`/group/history/orders?ep_id=*&status=1
				${(exceptType && `&excepttype=${exceptType}`) || ''}
				&=`)

	useEffect(() => {
		let exceptType = ''
		if (exceptType1) exceptType += `${exceptType ? ',' : ''}-2`
		if (exceptType2) exceptType += `${exceptType ? ',' : ''}-1`
		if (exceptType3) exceptType += `${exceptType ? ',' : ''}-9`
		if (exceptType4) exceptType += `${exceptType ? ',' : ''}6, -10`
		if (exceptType5) exceptType += `${exceptType ? ',' : ''}7`
		setExceptType(exceptType)
	}, [exceptType1, exceptType2, exceptType3, exceptType4, exceptType5])

	useEffect(() => {
		const url = `/group/history/orders?ep_id=*&status=1
				${(exceptType && `&excepttype=${exceptType}`) || ''}
				${search2 ? `&searchWord=${search2}` : ''}
				${group ? `&group=${group}` : ''}
				&=`
		setApi(url)
	}, [exceptType, search, search2, group])

	return (
		<CanvasTableAPI
			title={'미체결주문'}
			coinglobal={coinglobal}
			className={'plist'}
			footer={9}
			height={height}
			width={width}
			defaultMaxData={800}
			minusHeight={70}
			autorefresh={15000}
			loading={false}
			scale={scale}
			extra={
				<Space
					style={{
						whiteSpace: 'nowrap',
						alignContent: 'center',
						justifyItems: 'center',
						justifyContent: 'center',
					}}>
					<ExceptBox
						exceptType1={exceptType1}
						setExceptType1={setExceptType1}
						exceptType2={exceptType2}
						setExceptType2={setExceptType2}
						exceptType3={exceptType3}
						setExceptType3={setExceptType3}
						exceptType4={exceptType4}
						setExceptType4={setExceptType4}
						exceptType5={exceptType5}
						setExceptType5={setExceptType5}
					/>
					<SearchFilter
						search={search}
						search2={search2}
						setSearch={setSearch}
						setSearch2={setSearch2}
					/>
				</Space>
			}
			columns={PartnerRealtimeWaitColumn}
			usermodal={true}
			apikey={api}
		/>
	)
}

export default React.memo(PartnerRealtimeWait)
